module.exports = __webpack_public_path__ + "img/cat.c97b969e.png";